import { render, staticRenderFns } from "./StorageOrders.vue?vue&type=template&id=6e15919b&scoped=true"
import script from "./StorageOrders.vue?vue&type=script&lang=js"
export * from "./StorageOrders.vue?vue&type=script&lang=js"
import style0 from "./StorageOrders.vue?vue&type=style&index=0&id=6e15919b&prod&lang=less&scoped=true"
import style1 from "./StorageOrders.vue?vue&type=style&index=1&id=6e15919b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15919b",
  null
  
)

export default component.exports